<template>
  <div class="trainDetail">
    <div class="center" :style="isShare ? { width: '100vw' } : {}">
      <Breadcrumb v-if="!isShare" :list="breadList" />
      <div v-if="detail.name">
        <!-- <h1>{{  }}</h1> -->
        <div v-html="detail.name" style="text-align: center;"></div>
        <div class="pors" v-if="!isShare" id="train-detail-pors-id">
          <div class="fr" style="margin-left: 20px" @click="handleShare">
            <img src="../../assets/image/share-icon.png" alt="" />
            <span>分享</span>
          </div>
          <div class="fr" @click="handlePrint">
            <img src="../../assets/image/print-icon.png" alt="" />
            <span>打印</span>
          </div>
          <div class="clear"></div>
        </div>
        <div
          class="content trainDetail-content"
          :style="isShare ? { margin: '0 20px 50px 20px' } : {}"
          v-html="detail.content"
        ></div>
        <div
          class="junct"
          id="junct-id"
          v-if="list.length"
          :style="isShare ? { margin: '0 20px 50px 20px' } : {}"
        >
          <div class="title">附件:</div>
          <p v-for="(item, i) in list" :key="i">
            <a class="item" target="_blant" :href="item.url">{{ item.name }}</a>
          </p>
        </div>
        <el-button id="train-detail-id" v-if="!isMobileDevice()" class="btn" @click="dialogVisible = true"
          >合作咨询</el-button
        >
      </div>
      <div v-else class="empty">
        <img src="@/assets/images/empty.png" alt="">
        <div>暂无相关内容</div>
      </div>

    </div>

    <more-dialog
      ref="moreDialog"
      :dialog-visible="dialogVisible"
      @close="handleClose"
      @submit="submit"
    ></more-dialog>
    <PublicShare ref="shareRef" />
  </div>
</template>

<script>
import { getListTrain } from '@/api/face'
import Breadcrumb from '@/components/breadcrumb.vue'
import PublicShare from '../../components/publicShare.vue'
import MoreDialog from '../talentService/components/moreDialog.vue'
import { addMessageBoard } from '@/api/talentService'
export default {
  name: 'TrainDetail',
  components: { Breadcrumb, PublicShare, MoreDialog },
  data() {
    const { isShare = false } = this.$route.query
    return {
      breadList: [
        {
          label: '内训',
          path: '/trainDetail'
        }
      ],
      detail: {},
      list: [],
      dialogVisible: false,
      isShare: isShare === 'true'
    }
  },
  created() {
    if (this.isShare) document.body.style.minWidth = '100vw'
    this.getListTrain()
  },
  methods: {
    async getListTrain() {
      const res = await getListTrain({ status: 1 })
      this.detail = res.data.records[0]
      if (this.detail) {
        this.list = this.detail.adjunctUrl ? JSON.parse(this.detail.adjunctUrl) : []
      }
    },
    isMobileDevice() {
      const ua = navigator.userAgent.toLowerCase()
      const t1 = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua)
      const t2 = !ua.match('iphone') && navigator.maxTouchPoints > 1
      return t1 || t2
    },
    handleClose() {
      this.dialogVisible = false
      this.$nextTick(() => {
        this.$refs.moreDialog.$refs.ruleForm.resetFields()
      })
    },
    submit(data) {
      const form = {
        ...data,
        source: '内训'
      }
      addMessageBoard(form).then((res) => {
        const { code, message } = res
        if (code === 0) {
          this.dialogVisible = false
          this.$message.success('提交成功，我们会尽快回复您的申请～')
        } else {
          this.$message.error(message)
        }
      })
    },
    handlePrint() {
      window.print()
    },
    handleShare() {
      this.$refs.shareRef.handleShare('trainDetail', {
        isShare: true,
        hideHeader: true,
        hideFooter: true
      })
    }
  }
}
</script>
<style>
.trainDetail-content img{
  max-width: 90%;
}
</style>
<style lang="scss" scoped>
.trainDetail {
  .fr {
    float: right;
  }
  .clear {
    clear: both;
  }
  .center {
    width: 1300px;
    margin: 0 auto;
    margin-top: 30px;
    // padding: 0 36px;
    box-sizing: border-box;
    margin-bottom: 50px;
    background-color: #fff;
    padding-bottom: 108px;
    .empty{
      text-align: center;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #999999;
      img{
        width: 300px;
        margin: 50px 0 28px;
      }
    }
    h1 {
      max-width: 800px;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0853b6;
      text-align: center;
      margin: 20px auto 60px;
    }
    .pors {
      margin-bottom: 55px;
      padding-right: 88px;
      .fr {
        cursor: pointer;
        img,
        span {
          vertical-align: middle;
        }
        img {
          width: 24px;
          height: 24px;
        }
        span {
          font-size: 14px;
          color: #0854b6;
          font-weight: bold;
        }
      }
    }
    .content {
      margin: 0 80px;
      margin-bottom: 50px;
      :v-deep img {
        max-width: 90%;
      }
    }
    .junct {
      margin: 0 80px;
      margin-bottom: 80px;
      .title {
        text-decoration: underline;
        font-weight: 700;
      }
      p {
        margin: 10px 0;
        text-decoration: underline;
      }
    }
  }

  .btn {
    width: 200px;
    height: 50px;
    border-radius: 25px;
    margin: 40px auto;
    display: block;
    color: #fff;
    font-size: 24px;
    background: linear-gradient(90deg, #0f59be 0%, #496eee 100%);
    box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  }
}
</style>
